import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as Sentry from '@sentry/react';
import './i18n';
import pkg from '../package.json';
import {
  sanitizeBreadcrumb,
  sanitizeErrorEvent,
  sanitizeTransaction,
} from './utils/sentry-privacy';
const buildNumber = pkg.version;

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  environment: process.env.REACT_APP_SENTRY_ENVIRONMENT,
  tracesSampleRate: process.env.REACT_APP_SENTRY_TRACE_SAMPLE_RATE
    ? parseFloat(process.env.REACT_APP_SENTRY_TRACE_SAMPLE_RATE)
    : 0.001,
  sendDefaultPii: false,
  beforeSend: sanitizeErrorEvent,
  beforeSendTransaction: sanitizeTransaction,
  beforeBreadcrumb: sanitizeBreadcrumb,
  integrations: [
    Sentry.browserTracingIntegration({
      beforeStartSpan: (options) => ({
        ...options,
        name: 'Browser transaction',
      }),
    }),
  ],
  release: 'tvarkaumiesta-react@' + buildNumber,
  debug: process.env.REACT_APP_SENTRY_DEBUG === 'true',
  sampleRate: 1,
  ignoreErrors: [
    'AbortError: signal is aborted without reason',
    'AbortError: The operation was aborted.',
    'AbortError: Fetch is aborted',
  ],
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);
root.render(<App />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
